import LinksActions from '../../../../actions/LinksActions';
import query from '../../../../helpers/query';
import { removeParams } from '../helpers';
import CustomNotify from "../../../Notify";
import PromoCodeActions from "../../../../actions/PromoCodeActions";

const actions = {
    getLinks(state, actionType) {
        if (actionType === 'firstRender') {
            return;
        }

        const params = {
            ...query.parseToSend(state),
            ...removeParams(),
            q: state.nameLink,
            skip_containers: 1
        };

        LinksActions.getListLinks(params);
    },

    saveLinkPresets(state, t, onSuccess, onError, options = {}) {
        const { notify = true } = options || {};
        const notyNames = t.notyMessages;
        let linkParams = state.link.params;

        try {
            if(typeof linkParams === "string") {
                linkParams = linkParams.trim() ? JSON.parse(linkParams) : {};
            }
        } catch (e) {
            console.error('Failed to parse link params:', e);
            linkParams = {};
        }

        let cleanedParams = {};
        if (linkParams && typeof linkParams === 'object' && linkParams !== null) {
            Object.keys(linkParams).forEach((key) => {
                const value = linkParams[key];
                if (value && typeof value === 'string' && value.trim().length > 0) {
                    cleanedParams[key] = value;
                }
            });
        }

        let params = {
            publisher_id: state.publisherId,
            offer_id: state.link.offer.id,
            link_id: state.linkId,
            params: Object.keys(cleanedParams).length > 0 ? JSON.stringify(cleanedParams) : JSON.stringify({})
        };

        LinksActions.saveLinkPresets(params).then(data => {
            if (notify) {
                CustomNotify(notyNames.update);
            }
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err?.error?.invalid_parameters);
        });
    },

    savePromoCode(state, t, onSuccess, onError) {
        const notyNames = t.notyMessages;
        let linkParams = state.link.params;

        if(typeof linkParams === "string") {
            linkParams = JSON.parse(state.link.params);
        }

        let params = {
            goal_id: state.goal_id,
            publisher_id: state.publisherId,
            offer_id: state.link.offer.id,
            link_id: state.linkId,
            params: JSON.stringify(linkParams)
        };

        PromoCodeActions.savePromoCode(params).then(data => {
            CustomNotify(notyNames.update);
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err?.error?.invalid_parameters);
        });
    },

    deletePromoCode(id, t, onSuccess, onError) {
        const notyNames = t.notyMessages;

        let params = {
            id: id
        };

        PromoCodeActions.deletePromoCode(params).then(resp => {
            if (resp.success) {
                CustomNotify(resp.success);
            }
            onSuccess && onSuccess();
        }).catch(err => {
            if (err?.error) {
                CustomNotify(err.error, 'error')
            }
            onError && onError(err?.error?.invalid_parameters);
        });
    }
};

export default actions;
